<mat-card>
  <mat-card-title>{{ viewMode ? 'Revel Details' : 'Edit Revel' }}</mat-card-title>
  <mat-card-content>
    <form *ngIf="!viewMode" [formGroup]="editForm">
      <!-- Revel Name and Revel Date on the same row -->
      <div style="display: flex; gap: 16px;">
        <mat-form-field appearance="fill" style="flex: 2;">
          <mat-label>Revel Name</mat-label>
          <input matInput formControlName="revelName">
        </mat-form-field>

        <mat-form-field appearance="fill" style="flex: 1;">
          <mat-label>Revel Date</mat-label>
          <input matInput [matDatepicker]="picker" formControlName="revelDate">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>

      <!-- Revel Location and Revel Type on the same row -->
      <div style="display: flex; gap: 16px;">
        <mat-form-field appearance="fill" style="flex: 2;">
          <mat-label>Revel Location</mat-label>
          <input matInput formControlName="revelLocation">
        </mat-form-field>

        <mat-form-field appearance="fill" style="flex: 1;">
          <mat-label>Revel Type</mat-label>
          <input matInput formControlName="revelType">
        </mat-form-field>
      </div>

      <mat-checkbox formControlName="isPublic">Is Public</mat-checkbox>

      <mat-form-field appearance="fill">
        <mat-label>Comments</mat-label>
        <textarea matInput formControlName="comments" rows="5"></textarea>
      </mat-form-field>
    </form>

    <div *ngIf="viewMode">
      <p><strong>Revel Name:</strong> {{ data.revel?.revelName }}</p>
      <p><strong>Revel Date:</strong> {{ data.revel?.revelDate | date: 'yyyy-MM-dd' }}</p>
      <p><strong>Revel Location:</strong> {{ data.revel?.revelLocation }}</p>
      <p><strong>Revel Type:</strong> {{ data.revel?.revelType }}</p>
      <p><strong>Is Public:</strong> {{ data.revel?.isPublic ? 'Yes' : 'No' }}</p>
      <p><strong>Comments:</strong> {{ data.revel?.comments }}</p>
    </div>
  </mat-card-content>

  <!-- Revel Resources Section -->
  <mat-divider></mat-divider>
  <mat-card-content>
    <app-resource-revel 
      [revelId]="data.revel?.id ?? 0" 
      [viewMode]="viewMode">
    </app-resource-revel>
  </mat-card-content>

  <!-- Buttons at the bottom -->
  <mat-card-actions>
    <div *ngIf="!viewMode" class="form-actions">
      <button mat-raised-button color="primary" type="button" (click)="saveChanges()">Save</button>
      <button mat-raised-button color="warn" type="button" (click)="closeDialog()">Cancel</button>
    </div>
    <div *ngIf="viewMode">
      <button mat-raised-button color="primary" type="button" (click)="closeDialog()">Close</button>
    </div>
  </mat-card-actions>
</mat-card>
